import { useLiveQuery, useStore } from "@hq/client-react";

export const SIDEBAR_ID = "workspace-sidebar";

export function useSidebarState() {
  const store = useStore();
  const { data: collapsed = false } = useLiveQuery(
    ["kv"],
    (s) => s.kv.get<boolean>("sidebar.collapsed"),
    [],
  );
  return {
    collapsed,
    toggle: () => void store.kv.set("sidebar.collapsed", !collapsed),
  };
}
